// Cálculos automáticos a partir de un campo de fecha (edad, antigüedad,
// tiempo transcurrido). Se usa en formularios e inspecciones. Mantener en
// sincronía con sst-backend/dateCalculations.js.

export const DATE_CALCULATION_LABELS = {
  age: "Edad",
  seniority: "Antigüedad",
  elapsed: "Tiempo transcurrido",
};

export function calculationLabel(dateCalculation) {
  return DATE_CALCULATION_LABELS[dateCalculation] || "Cálculo";
}

// Encabezado de la columna/fila aparte donde va el resultado, o null si el
// campo no tiene cálculo automático.
export function calculatedColumnLabel(field) {
  if (field.type !== "date" || !field.dateCalculation) return null;
  return `${calculationLabel(field.dateCalculation)} (${field.label})`;
}

function pluralize(value, singular, plural) {
  return `${value} ${value === 1 ? singular : plural}`;
}

// Fecha (sin hora) en zona horaria de Colombia, para que el servidor en UTC
// no cambie el día cerca de la medianoche.
function bogotaDay(reference) {
  const date = reference ? new Date(reference) : new Date();
  if (Number.isNaN(date.getTime())) return null;
  const [year, month, day] = date.toLocaleDateString("en-CA", { timeZone: "America/Bogota" }).split("-").map(Number);
  return new Date(year, month - 1, day);
}

// Hoy en Colombia como "AAAA-MM-DD" (para el atributo max de los inputs).
export function todayISO() {
  return new Date().toLocaleDateString("en-CA", { timeZone: "America/Bogota" });
}

// Las fechas con cálculo automático (nacimiento, ingreso...) no pueden ser
// posteriores a hoy. Las cadenas AAAA-MM-DD se comparan bien como texto.
export function isFutureDate(rawValue) {
  return !!rawValue && String(rawValue) > todayISO();
}

// rawValue: "AAAA-MM-DD". reference: fecha contra la que se calcula (por
// defecto hoy; en resultados se usa la fecha de envío).
export function calculateDateValue(rawValue, dateCalculation, reference) {
  if (!rawValue || !dateCalculation) return "";

  const date = new Date(`${rawValue}T00:00:00`);
  const current = bogotaDay(reference);
  if (Number.isNaN(date.getTime()) || !current) return "";

  let years = current.getFullYear() - date.getFullYear();
  let months = current.getMonth() - date.getMonth();
  let days = current.getDate() - date.getDate();

  if (days < 0) {
    days += new Date(current.getFullYear(), current.getMonth(), 0).getDate();
    months -= 1;
  }
  if (months < 0) {
    months += 12;
    years -= 1;
  }

  const safeYears = Math.max(0, years);
  const safeMonths = Math.max(0, months);
  const safeDays = Math.max(0, days);

  if (!DATE_CALCULATION_LABELS[dateCalculation]) return "";

  // Siempre el desglose completo: "36 años, 5 meses y 17 días"
  return `${pluralize(safeYears, "año", "años")}, ${pluralize(safeMonths, "mes", "meses")} y ${pluralize(safeDays, "día", "días")}`;
}

export function calculateDateMetadata(rawValue, dateCalculation, reference) {
  const value = calculateDateValue(rawValue, dateCalculation, reference);
  if (!value) return null;
  return { label: calculationLabel(dateCalculation), type: dateCalculation, value };
}

